/* Copyright (c) 2025 Xperi. All Rights Reserved. */

/**
 * This file implements all the functions for Filtered Guide feature,
 * which are exposed from the data/domain layer to other layers.
 * Any modifications to the exposed functions can be made here
 */
import { Category, GuideProgramList } from 'client-code/filtered-guide';
import { TIVO_SERVICES } from 'src/config';

import { DeviceFeatures, DeviceModel } from '../device';
import { Channel } from '../entities';
import { ChannelsService, FilteredGuideService, Services } from '../infrastructure';
import { TiVoNetworkRequestModel } from '../tivo';
import { TChannelV2 } from '../types';
import { ServicesClientImpl } from './ServicesClientImpl';
import { VodInteractor } from './VodInteractor';

export class FilteredGuideInteractor extends VodInteractor {
    public fetchFilteredGuideData = (
        category: Category,
        startTime: Date,
        channelFilter?: 'favorites' | 'subscribed' | undefined,
        offset: number = 0,
        count: number = 1000,
        requestTokenHeader: string | undefined = undefined,
    ): TiVoNetworkRequestModel<GuideProgramList> => {
        const filteredGuideInstance = Services.getInstanceOf(FilteredGuideService, {
            accessToken: DeviceModel.getAccessToken(),
            bodyId: DeviceModel.getTiVoSettings().getBodyId(),
            basePath: ServicesClientImpl.servicesBaseUrls[TIVO_SERVICES.FilteredGuideService],
            whiny: DeviceFeatures.isWhinyLoggingEnabled().toString(),
            msoPartnerId: DeviceModel.getTiVoSettings().getMsoPartnerId(),
            requestTokenHeader,
        });
        return filteredGuideInstance.fetchFilteredPrograms(
            category,
            startTime,
            channelFilter,
            offset,
            count,
        );
    };

    public fetchFilteredOutChannels = async (): Promise<Array<Channel>> => {
        const service = Services.getInstanceOf(ChannelsService, this.getChannelsServiceParams());
        const data = await service.fetchFilteredOutChannels();

        return data;
    };

    public fetchFilteredOutChannelsV2 = async (): Promise<Array<TChannelV2>> => {
        const service = Services.getInstanceOf(ChannelsService, this.getChannelsServiceParams());
        const data = await service.fetchFilteredOutChannelsV2();

        return data;
    };
}
